













import { FormRow } from '../../../models/Form';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class DescriptionField extends Vue {
  @Prop({ type: Object, required: true }) row!: FormRow;
  @Prop({ type: Function }) onClick!: Function;

  handleClick() {
    if (this.onClick) {
      this.onClick(this.row.tip); 
    }
  }
}
